import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[accordionHeaderContent]'
})
export class AccordionHeaderContentDirective {

  constructor(public templateRef: TemplateRef<any>) {
  }
}
